import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging from "biz-ts/src/api/Paging";
import Company from "@/model/Company";
import {CcreateForm, CeditForm, CpqForm} from '@/form/CompanyForm';

@Singleton
export default abstract class CompanyApi {

    abstract query(id: number): Promise<Company>

    abstract paging(form: CpqForm): Promise<Paging<Company>>

    abstract list(): Promise<Array<Company>>

    abstract create(form: CcreateForm): Promise<Company>

    abstract edit(form: CeditForm): Promise<Company>

    abstract delete(id: number): Promise<void>
}

class CompanyApiImpl extends BaseApi implements CompanyApi {

    protected urlPrefix = 'company'

    query(id: number): Promise<Company> {
        return this.axios.post('query', {id: id})
    }

    paging(form: CpqForm): Promise<Paging<Company>> {
        return this.axios.post('paging', form)
    }

    list(): Promise<Array<Company>> {
        return this.axios.post('list')
    }

    create(form: CcreateForm): Promise<Company> {
        return this.axios.post('create', form)
    }

    edit(form: CeditForm): Promise<Company> {
        return this.axios.post('edit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }
}

Container.bind(CompanyApi).to(CompanyApiImpl)
